export default __webpack_public_path__ + "static/media/ajanvaraus.d2606588.svg";